export default __webpack_public_path__ + "static/cercle_vicieux_es-9e36a6b19703cd15d5a927cb9300b822.mp4";